import { getRequest, postRequest } from '@bo-apis/axios';

const getCoNotificationList = ({ searchForm, pageable }) => {
  return postRequest({
    url: 'api/v1/co/customer-service/notification/get-notification-list',
    params: { ...pageable },
    data: { ...searchForm },
  });
};
const getCoNotificationDetail = (notificationNumber) => {
  return getRequest({
    url: `api/v1/co/customer-service/notification/${notificationNumber}`,
  });
};

export { getCoNotificationList, getCoNotificationDetail };
